<template>
  <div class="otherInfos">
    <div class="otherInfos-wrapper">
      <div class="otherInfos-item">
        <div @click="countryDialog" v-if="selectedText.length > 0">{{ selectedText[0].label }}</div>
        <div>{{ $t("mall.Nationality") }}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="otherInfos-item">
        <div @click="dateDialog">{{ RoleInfo.BirthDate }}</div>
        <div>{{ $t("mall.Birthday") }}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="otherInfos-item">
        <div>
          <span v-for="(item, index) in Sexs" style="padding-right: 0.532rem" :key="item.CategoryID">
            <input v-model="RoleInfo.RoleGenre" style="width: 0.532rem;height: 0.532rem;vertical-align: middle;" :id="'Sex' + index" type="radio" :key="item.CategoryID" :value="item.CategoryID" />
            <label style="vertical-align: middle;" :for="'Sex' + index">{{ $t("Categorys." + item.CategoryCode) }}</label>
          </span>
        </div>
        <div>{{ $t("mall.Sex") }}</div>
      </div>
      <div class="border_bottom"></div>
      <div class="otherInfos-item">
        <div>
          <input v-model="ContactInfo.ContactPhone" type="tel" :placeholder="$t('placeholders.Phone')" />
        </div>
        <div>{{ $t("mall.Phone") }}</div>
      </div>
      <div class="otherInfos-item">
        <div>
          <input v-model="ContactInfo.ContactEmail" :placeholder="$t('mall.Email')" />
        </div>
        <div>{{ $t("mall.Email") }}</div>
      </div>
      <div class="border_bottom"></div>
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
    <datePicker @input="handleSelectDate" ref="datePicker" :data="AllDates" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt" :selected-index="selectedDatePickerIndex[0]"></datePicker>
  </div>
</template>
<style scoped>
  .otherInfos-item {
    position: relative;
  }

  .otherInfos-item > div {
    font-size: 0.399rem;
  }

  .otherInfos-item > div:first-child {
    margin-left: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .otherInfos-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .otherInfos-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .otherInfos-item img {
    width: 0.372rem;
    vertical-align: middle;
  }

  .otherInfos-item input {
    width: 100%;
    height: 100%;
    border: 0;
    vertical-align: top;
  }

  .otherInfos-item input:focus {
    outline: 0;
  }

  .otherInfos-item input::-webkit-input-placeholder {
    color: #b6b6b6;
  }

  .otherInfos-item input:-moz-placeholder {
    color: #b6b6b6;
  }

  .otherInfos-item input:-ms-input-placeholder {
    color: #b6b6b6;
  }
</style>
<script>
  import radioOption from "../../modules/radio-option.vue";
  import SwitchOption from "../../modules/switch-option.vue";
  import picker from "../../modules/picker.vue";
  import datePicker from "../../modules/date-picker.vue";
  import enumUtils from "@/utils/enumUtils";
  import { Categorys } from "@/model/Base";
  import baseService from "@/service/baseService";
  export default {
    data() {
      return {
        selectedIndex: [],
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
        isAutoPlay: false,
        CountryLists: [],
        AllDates: [
          {
            minDate: 1899,
            maxDate: 2200,
          },
          {
            minDate: 0,
            maxDate: 12,
          },
          {
            minDate: 0,
            maxDate: 31,
          },
        ],
        selectedDatePickerText: "",
        selectedDatePickerIndex: [[0, 0, 0]],
      };
    },
    props: ["RoleInfo", "ContactInfo"],
    computed: {
      Sexs() {
        return enumUtils.makeCategorys(Categorys.Sex);
      },
    },
    created() {
      this.getCountrys();
    },
    watch: {
      "RoleInfo.CountryID"(newVal) {
        let __self = this;
        __self.selectedText = [];
        for (let i = 0; i < __self.CountryLists.length; i++) {
          let CountryList = __self.CountryLists[i];
          CountryList.label = CountryList.CountryName;
          if (CountryList.CountryID == newVal) {
            __self.selectedText.push(CountryList);
            __self.$refs.picker.setSelectedIndex([i]);
          }
          __self.$refs.picker.setData([__self.CountryLists]);
        }
      },
      "RoleInfo.BirthDate"(newVal) {
        let __self = this;
        __self.selectedDatePickerText = newVal.toString();
        __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
      },
    },
    mounted() {
      let __self = this;
      __self.selectedDatePickerText = __self.RoleInfo.BirthDate.toString();
      __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
      window.__self = __self;
    },
    methods: {
      getCountrys() {
        let __self = this;
        let data = {
          ZoneType: "1442",
          PageSize: 999999,
        };
        baseService.getZoneList(data).then(function(json) {
          if (json.isSucc) {
            __self.CountryLists = json.result.entities;
            __self.CountryLists.forEach((o, index) => {
              o.label = o.CountryName;
              if (o.CountryID == __self.RoleInfo.Country) {
                __self.CountryCode = o.ZoneCode;
                __self.selectedText.push(o);
                __self.$refs.picker.setSelectedIndex([index]);
              }
              __self.$refs.picker.setData([__self.CountryLists]);
            });
          }
        });
      },
      dateDialog() {
        let __self = this;
        __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
        __self.$refs.datePicker.show();
      },
      handleSelectDate(value) {
        let __self = this;
        __self.selectedDatePickerText = value;
        __self.RoleInfo.BirthDate = value;
      },
      updateAutoPlay(val) {
        this.isAutoPlay = val;
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.RoleInfo.Country = __self.selectedText[0].CountryID;
        __self.CountryCode = __self.selectedText[0].ZoneCode;
      },
      countryDialog() {
        this.$refs.picker.show();
      },
    },
    components: {
      picker,
      SwitchOption,
      datePicker,
      radioOption,
    },
  };
</script>
